import { formatDate } from '../../../utils/formatDate';

// Credits render as ($270.00) rather than -$270.00 so a negative balance reads
// as a credit to customers and staff instead of looking like a typo.
const dollarFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  currencySign: 'accounting',
});

export const formatDollar = (amount: number): string => dollarFormatter.format(amount);

export const formatDepartmentGroups = (groups: string[]): string => (groups.length > 0 ? groups.join(', ') : '—');

export const formatOptionalDate = (isoLike: string | null): string => {
  if (!isoLike) return '—';
  return formatDate(isoLike) || '—';
};

export const permanentOffTooltip = (name: string | null, at: string | null, reason: string | null): string => {
  const who = name || 'An admin';
  const when = at ? new Date(at).toLocaleString() : 'an unknown date';
  return `${who} turned collections off on ${when} — reason: ${reason || 'not provided'}`;
};

export const ADMIN_ONLY_TOGGLE_TOOLTIP = 'Only an admin can turn collection emails on/off.';
export const ADMIN_ONLY_PERMANENT_TOOLTIP = 'Only an admin can permanently disable collection emails.';
